module.exports = __webpack_public_path__ + "img/PriceQuotations_InJobOrder.43c9ef5f.svg";